<template>
  <div class="wrapper">
    <TopNavbar @switchApp="switchApp" />
    <div v-if="$route.name !== 'Settings'" data-rf-zone="top-notification-bar" class="mt-12"></div>
    <LeftMainNav
      v-if="currApp"
      :apps="appsStore.apps"
      :currApp="currApp"
      :docsUrl="appsStore.docsUrl"
      @clickLive="() => domainChooseDialog?.open()"
      @switchApp="switchApp"
    />
    <div class="main-panel">
      <div :class="currClasses">
        <RouterView v-if="currApp || isSettingsRoute"></RouterView>
        <div
          v-else-if="!legacyLastErrorStore.loading"
          class="absolute inset-0 left-16 z-0 flex h-full"
        >
          <div class="m-auto inline-flex flex-col items-center gap-4 pt-10 text-center">
            <span class="text-heading-1 text-beige-90 uppercase">Insufficient Access</span>
            <span class="text-heading-2 font-normal!">
              Please contact your admin user to authorize access
            </span>
          </div>
        </div>
      </div>
    </div>
    <RfModalLoading :showDialog="legacyLastErrorStore.loading > 0" />
    <RfToastContainer :toasts="toastsStore.toasts" @close="toastsStore.remove" />
    <RfDomainChooserWrapper ref="domainChooseDialog" @open="openLivePreview" />
  </div>
</template>

<script setup>
import { computed, useTemplateRef } from "vue";
import { useRouter, useRoute, RouterView } from "vue-router";
import TopNavbar from "@/views/dashboard/Layout/TopNavbar.vue";
import LeftMainNav from "@/views/dashboard/Layout/LeftMainNav.vue";
import { useLive } from "@/utils/composables/useLive";
import RfDomainChooserWrapper from "@/components/RfCommonCards/RfDomainChooserWrapper.vue";
import copyToClipboard from "@/utils/CopyToClipboard";
import RfToastContainer from "@/blocks/RfToastContainer.vue";
import { useToastsStore } from "@/pinia/toastsStore";
import { useAppsStore } from "@/pinia/appsStore";
import { useLegacyLastErrorStore } from "@/pinia/legacyLastErrorStore";
import RfModalLoading from "./RfModalLoading.vue";

const router = useRouter();
const route = useRoute();
const toastsStore = useToastsStore();
const appsStore = useAppsStore();
const legacyLastErrorStore = useLegacyLastErrorStore();
const live = useLive();
const domainChooseDialog = useTemplateRef("domainChooseDialog");

const currApp = computed(() => appsStore.app);

const isSettingsRoute = computed(() => route.path.startsWith("/settings"));

const currClasses = computed(() => ({
  "content": !route.meta.hideContent,
  "prompt-flag-enabled": true,
  "prompt-tab-view-disabled": true,
}));

const switchApp = app => {
  if (!app?.id) return;
  const pathFull = `/apps/${app.id}/dashboard`;

  if (app.id === currApp.value?.id) {
    router.push(pathFull);
    return;
  }
  window.location.replace(pathFull);
};

const openLivePreview = domain => {
  live.openLiveUrl(null, domain);
  domainChooseDialog.value?.close();
  toastsStore.create({
    type: "info",
    body: "Copy Real Time params to clipboard",
    action: { title: "Copy", handler: () => copyToClipboard(live.realtimeParams.value) },
    timeout: 30000,
  });
};
</script>

<style lang="scss" scoped>
.content {
  margin: var(--main-margin-top, 48px) 0 0 var(--left-main-bar-width, 60px);
  width: calc(100% - var(--left-main-bar-width, 60px));
  transition:
    width 100ms ease-in-out,
    margin 100ms ease-in-out;
  min-height: 90vh;
}
</style>
